import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { toast } from "sonner";

const FIELDS = [
  { key: "phone", label: "Phone", placeholder: "(513) 260-0899" },
  { key: "email", label: "Email", placeholder: "you@example.com" },
  { key: "location", label: "Location", placeholder: "Middletown, New Jersey" },
  { key: "hours", label: "Business Hours", placeholder: "Mon – Fri: 9AM – 5PM" },
  { key: "instagram", label: "Instagram handle (without @)", placeholder: "briars_unlimited" },
];

export const BusinessInfoTab = () => {
  const { refresh } = useSettings();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings")
      .then(({ data }) => setForm({ phone: "", email: "", location: "", hours: "", instagram: "", ...data }))
      .catch(() => setForm({ phone: "", email: "", location: "", hours: "", instagram: "" }));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      refresh();
      toast.success("Business info updated — it's now live on your site.");
    } catch {
      toast.error("Couldn't save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (!form) return <p className="text-navy/50" data-testid="business-info-loading">Loading…</p>;

  return (
    <div data-testid="business-info-tab" className="max-w-[560px]">
      <p className="text-navy/60 text-sm mb-1">This information appears in your site footer, Contact page, and About page.</p>
      <p className="text-navy/40 text-xs mb-8">Changes go live instantly — no redeploy needed.</p>
      <form onSubmit={save} className="space-y-5" data-testid="business-info-form">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="block text-xs tracking-[0.14em] text-navy/60 font-semibold mb-1.5">{f.label.toUpperCase()}</label>
            <input
              value={form[f.key] || ""}
              onChange={set(f.key)}
              placeholder={f.placeholder}
              data-testid={`settings-${f.key}-input`}
              className="w-full border border-line bg-white px-4 py-3 text-sm outline-none focus:border-navy transition-colors"
            />
          </div>
        ))}
        <button
          type="submit" disabled={saving} data-testid="settings-save-button"
          className="flex items-center gap-2 bg-ink text-[#f2f0ea] px-7 py-3.5 text-xs font-bold tracking-[0.16em] hover:bg-navy transition-colors disabled:opacity-60"
        >
          {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />}
          {saving ? "SAVING…" : "SAVE CHANGES"}
        </button>
      </form>
    </div>
  );
};
